import Int64LookupResourcePagingResultModel from '../../generated/types/model/resource/Int64LookupResourcePagingResultModel';

export default class Int64LookupResourcePagingResultViewModel extends Int64LookupResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
